import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { GetAllCounter } from "../../../lib/api";
import { Link, useNavigate } from "react-router-dom";
import { RouteNavigation } from "../../../Routes";
import {
  ShowLoadingAnimation,
  ShowNoDataAnimation,
} from "../../../components/common/Animation";
import { FaRegEdit } from "react-icons/fa";

const CounterList = () => {
  const { isLoading, isPending, isError, data } = useQuery({
    queryKey: ["GetAllCounter"],
    queryFn: () => GetAllCounter(),
  });


  const navigate = useNavigate();
  const isCounterData = data?.data;
  console.log(isCounterData,"data");
  return (
    <div className="py-5">
      <h4 className="text-3xl font-bold mb-5">Counter List</h4>
      <div className="flex justify-end">
        <Link to={RouteNavigation.create_counter}>
          <button className="bg-gray-800 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Create New
          </button>
        </Link>
      </div>
      {isLoading || isPending ? (
        <div className="w-44 flex justify-center m-auto">
          <ShowLoadingAnimation />
        </div>
      ) : (
        <div className="w-full">
          <div className="mt-5 border-2 rounded-lg">
            <div className="overflow-auto">
              <TableContainer>
                <Table>
                  <TableHead className="bg-gray-800 rounded-xl">
                    <TableRow>
                      <TableCell style={{ color: "white" }}>SL No</TableCell>
                      <TableCell style={{ color: "white" }}>Name</TableCell>
                      <TableCell style={{ color: "white" }}>
                        Department Name
                      </TableCell>
                      <TableCell style={{ color: "white" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  {!isPending && !isLoading && !isError && (
                    <TableBody>
                      {data?.data?.map((counter, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{counter.CounterName}</TableCell>
                          <TableCell>{counter.DepName}</TableCell>
                          <TableCell
                            onClick={() =>
                              navigate("/create-counter", {
                                state: { CounterData: counter },
                              })
                            }
                          >
                            <div className="flex justify-center">
                              <FaRegEdit
                                className="cursor-pointer"
                                size={"20px"}
                                color={
                                  counter.Status === true ? "green" : "red"
                                }
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center">
        {isError && !isCounterData && (
          <div className="w-44 flex justify-center">
            <ShowNoDataAnimation />
          </div>
        )}
      </div>
    </div>
  );
};
export default CounterList;
